import React from 'react';
import { useCallback, useRef } from 'react';
import { Transition as ReactTransitionGroupTransition } from 'react-transition-group';
import { isMotionDisabled } from '../../motion';
/**
 * This component is a wrapper around the CSSTransition component.
 *
 * It provides a second parameter in its rendering function that must be
 * attached to the node that is transitioning.
 */
export function Transition(_a) {
    var isIn = _a["in"], children = _a.children, _b = _a.exit, exit = _b === void 0 ? true : _b;
    var transitionRootElement = useRef(null);
    var motionDisabled = transitionRootElement.current ? isMotionDisabled(transitionRootElement.current) : true;
    var addTransitionEndListener = useCallback(function (done) {
        var node = transitionRootElement.current;
        if (node === null) {
            return;
        }
        var listener = function (e) {
            if (e.target === node) {
                node.removeEventListener('transitionend', listener);
                node.removeEventListener('animationend', listener);
                done();
            }
        };
        node.addEventListener('transitionend', listener);
        node.addEventListener('animationend', listener);
    }, []);
    return (React.createElement(ReactTransitionGroupTransition, { timeout: motionDisabled ? 0 : undefined, "in": isIn, addEndListener: addTransitionEndListener, nodeRef: transitionRootElement, exit: exit }, function (state) { return children(state, transitionRootElement); }));
}
//# sourceMappingURL=index.js.map